import { Portal, VStack, useDisclosure } from "@chakra-ui/react"
import useHoverCardOrPopover from "@pathwright/ux/src/components/chakra/useHoverCardOrPopover"
import classnames from "classnames"
import { useEffect } from "react"
import styled from "styled-components"
import OverlayTrigger from "../overlay/OverlayTrigger"
import Avatar from "./Avatar"
import AvatarCard from "./AvatarCard"
import "./AvatarCardTrigger.css"

const StyledOverlayTrigger = styled(OverlayTrigger)`
  .Overlay {
    cursor: initial;
  }
`

const StyledAvatarCard = styled(AvatarCard)`
  border-radius: inherit;
  padding: 1em;

  .Avatar {
    cursor: pointer;
  }
`

const AvatarCardTrigger = (props) => {
  const {
    size = "60px",
    user,
    meta = [],
    renderDropdown = null,
    onClickAvatar,
    trigger = "hover",
    placement = "bottom",
    alignment = "center",
    delayShow = 150,
    delayHide = 150,
    active = true,
    children
  } = props
  const className = classnames("AvatarCardTrigger", props.className)
  const { open, onOpen, onClose, onToggle } = useDisclosure()
  const {
    open: isAvatarCardOpen,
    onOpen: onOpenAvatarCard,
    onClose: onCloseAvatarCard
  } = useDisclosure()

  useEffect(() => {
    if (isAvatarCardOpen !== open) onToggle()
  }, [isAvatarCardOpen])

  const HoverCardOrPopover = useHoverCardOrPopover()

  return (
    <HoverCardOrPopover.Root
      open={open}
      openDelay={delayShow}
      closeDelay={delayHide}
      onOpenChange={(e) => (e.open ? onOpen() : onClose())}
      positioning={{ placement, alignment }}
      portalled
    >
      <HoverCardOrPopover.Trigger
        asChild
        className="AvatarCardTrigger__Trigger"
      >
        <VStack gap={1}>
          <Avatar user={user} size={size} onClick={onClickAvatar} />
          {children}
        </VStack>
      </HoverCardOrPopover.Trigger>
      <Portal>
        <HoverCardOrPopover.Positioner>
          <HoverCardOrPopover.Content
            className={className}
            width="auto"
            p={0}
            borderRadius="card"
            boxShadow="lg"
            onClick={(e) => {
              e.stopPropagation()
            }}
            css={{
              "--popover-bg": "white",
              "--hovercard-bg": "white"
            }}
          >
            <HoverCardOrPopover.Arrow />
            <StyledAvatarCard
              user={user}
              meta={meta}
              onClickAvatar={onClickAvatar}
              dropdownTriggerProps={{
                renderDropdown,
                onShow: onOpenAvatarCard,
                onHide: onCloseAvatarCard
              }}
            />
          </HoverCardOrPopover.Content>
        </HoverCardOrPopover.Positioner>
      </Portal>
    </HoverCardOrPopover.Root>
  )
}

AvatarCardTrigger.displayName = "AvatarCardTrigger"

AvatarCardTrigger.propTypes = {
  user: Avatar.propTypes.user,
  size: Avatar.propTypes.size,
  onClickAvatar: AvatarCard.propTypes.onClickAvatar,
  meta: AvatarCard.propTypes.meta,
  renderDropdown: AvatarCard.propTypes.renderDropdown
}

export default AvatarCardTrigger
